// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.refund-detail-container {
  padding: 30px;
  max-width: 1000px;
}

.refund-detail-title {
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 30px;
}

.refund-section {
  margin-bottom: 30px;
}

.refund-section-title {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 15px;
}

.refund-info-box {
  background-color: #FFF8F2;
  border-radius: 8px;
  padding: 20px;
}

.refund-info-item {
  display: flex;
  margin-bottom: 15px;
}

.refund-info-item:last-child {
  margin-bottom: 0;
}

.refund-info-label {
  width: 120px;
  font-weight: bold;
}

.refund-info-value {
  flex: 1 1;
}

.refund-reason-box {
  display: flex;
  flex-direction: column;
}

.refund-reason-type {
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 8px 8px 0 0;
  background-color: #FFF8F2;
}

.refund-reason-detail {
  padding: 20px;
  border: 1px solid #ddd;
  border-top: none;
  border-radius: 0 0 8px 8px;
  min-height: 150px;
  white-space: pre-line;
}

.refund-actions {
  margin-top: 40px;
}

.check-policy-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: none;
  border: 1px solid #ddd;
  cursor: pointer;
  padding: 0 20px;
  margin-bottom: 40px;
  font-size: 16px;
  border-radius: 5px;
  background-color: #f8f9fa;
  color: #000;
  width: 275px;
  height: 50px;
}

.arrow-icon {
  color: #00cc00;
}

.refund-decision-buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.approve-button, .reject-button {
  padding: 15px 30px;
  border-radius: 5px;
  border: none;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  width: 220px;
}

.approve-button {
  background-color: #FF6F0F;
  color: white;
}

.reject-button {
  background-color: #4B5EFC;
  color: white;
}

.loading, .error {
  text-align: left;
  padding: 50px;
  font-size: 18px;
  color: #666;
} `, "",{"version":3,"sources":["webpack://./src/styles/admin/AdminRefundDetail.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,WAAW;AACb","sourcesContent":[".refund-detail-container {\n  padding: 30px;\n  max-width: 1000px;\n}\n\n.refund-detail-title {\n  font-size: 28px;\n  font-weight: bold;\n  margin-bottom: 30px;\n}\n\n.refund-section {\n  margin-bottom: 30px;\n}\n\n.refund-section-title {\n  font-size: 22px;\n  font-weight: bold;\n  margin-bottom: 15px;\n}\n\n.refund-info-box {\n  background-color: #FFF8F2;\n  border-radius: 8px;\n  padding: 20px;\n}\n\n.refund-info-item {\n  display: flex;\n  margin-bottom: 15px;\n}\n\n.refund-info-item:last-child {\n  margin-bottom: 0;\n}\n\n.refund-info-label {\n  width: 120px;\n  font-weight: bold;\n}\n\n.refund-info-value {\n  flex: 1;\n}\n\n.refund-reason-box {\n  display: flex;\n  flex-direction: column;\n}\n\n.refund-reason-type {\n  padding: 15px;\n  border: 1px solid #ddd;\n  border-radius: 8px 8px 0 0;\n  background-color: #FFF8F2;\n}\n\n.refund-reason-detail {\n  padding: 20px;\n  border: 1px solid #ddd;\n  border-top: none;\n  border-radius: 0 0 8px 8px;\n  min-height: 150px;\n  white-space: pre-line;\n}\n\n.refund-actions {\n  margin-top: 40px;\n}\n\n.check-policy-button {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: none;\n  border: 1px solid #ddd;\n  cursor: pointer;\n  padding: 0 20px;\n  margin-bottom: 40px;\n  font-size: 16px;\n  border-radius: 5px;\n  background-color: #f8f9fa;\n  color: #000;\n  width: 275px;\n  height: 50px;\n}\n\n.arrow-icon {\n  color: #00cc00;\n}\n\n.refund-decision-buttons {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n}\n\n.approve-button, .reject-button {\n  padding: 15px 30px;\n  border-radius: 5px;\n  border: none;\n  font-size: 16px;\n  font-weight: bold;\n  cursor: pointer;\n  width: 220px;\n}\n\n.approve-button {\n  background-color: #FF6F0F;\n  color: white;\n}\n\n.reject-button {\n  background-color: #4B5EFC;\n  color: white;\n}\n\n.loading, .error {\n  text-align: left;\n  padding: 50px;\n  font-size: 18px;\n  color: #666;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
